import React, {useEffect, useState} from "react";
import {Spinner, FormHelperText, Box, MenuItem, TextField} from "@leap4/frontend";

export interface ITaskTypeSelectProps {
    onUpdate: (value: string) => void
    currentValue: string
    getTypes: () => Promise<string[]>
}

const TaskTypeSelect = (props: ITaskTypeSelectProps): JSX.Element => {

    const {currentValue, getTypes, onUpdate} = props;

    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isLoadError, setIsLoadError] = useState<boolean>(false)
    const [types, setTypes] = useState<string[]>([])

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            setTypes([])
            try {
                const data = await getTypes();
                setTypes(data);
            } catch (e) {
                setIsLoadError(true);
            } finally {
                setIsLoading(false)
            }
        })()
    }, [])

    const shouldDisplay = !isLoadError && !isLoading;

    return (
        <Box>
            <FormHelperText>
                <b>Task Type</b>
            </FormHelperText>
            <TextField
                fullWidth
                select
                required
                // label="Task Types"
                value={currentValue}
                onChange={(e) => onUpdate(e.target.value)}
                name="type">
                {isLoading && <Spinner/>}
                {isLoadError && <span>"Error loading types"</span>}
                {(shouldDisplay && types.length === 0) && (<span>"No Types found"</span>)}
                {(shouldDisplay && types.length > 0) && (
                    types.map((t, idx) => {
                            return (
                                <MenuItem value={t as string} key={idx}>
                                    {t}
                                </MenuItem>
                            );
                        }
                    )
                )}
            </TextField>
        </Box>
    )
}

export {TaskTypeSelect}


